import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";

export const GroupList = ({ groups, selectedId, onSelect }) => (
  <Card className="h-fit">
    <CardHeader className="pb-3">
      <CardTitle className="text-base flex items-center gap-2">
        <Users className="w-4 h-4" /> Gruppen
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-1">
      {groups.length === 0 && (
        <p className="text-sm text-muted-foreground py-2">Noch keine Gruppen</p>
      )}
      {groups.map((g) => (
        <button
          key={g.id}
          onClick={() => onSelect(g.id)}
          className={`w-full text-left px-3 py-2.5 rounded-lg transition-colors flex items-center justify-between gap-2 ${
            selectedId === g.id ? "bg-primary text-primary-foreground" : "hover:bg-muted"
          }`}
          data-testid={`group-item-${g.id}`}
        >
          <span className="flex items-center gap-2 min-w-0">
            <span className="truncate font-medium">{g.name}</span>
            {g.is_default && (
              <Badge variant={selectedId === g.id ? "secondary" : "outline"} className="text-[10px] shrink-0">Standard</Badge>
            )}
          </span>
          <span className={`text-xs shrink-0 ${selectedId === g.id ? "text-primary-foreground/80" : "text-muted-foreground"}`}>
            {g.contacts?.length || 0}
          </span>
        </button>
      ))}
    </CardContent>
  </Card>
);
